import { createContext } from 'react';

export const GamesContext = createContext([]);
export const AuthContext = createContext({
    user: null,
    userData: null,
    userRef: null,
    loading: true,
});